<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">Cover Design: <a href="http://www.written-ink.com" target="_blank"><span class="t4">Written Ink Designs</span></a> | written-ink.com</p>
<p class="p3">Image(s) used under a Standard Royalty-Free License.</p>
<p class="p3">All rights reserved.</p>
<p class="p4"> </p>
<p class="p4">WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.</p>
<p class="p4">No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.</p>
<p class="p4">This book is for ADULT AUDIENCES ONLY. It may contain sexually explicit scenes and graphic language which might be considered offensive by some readers. Please store your files where they cannot be accessed by minors.</p>
<p class="p4">This is a work of fiction. Names, characters, places, and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.</p>
<p class="p4">Published in the United States of America.</p>
<p class="p5">* * * *</p>
<p class="p4">Gabi Cervenka and Leonie Duncan, thank you!</p>
<p class="p4">I wrote <span class="t5">The Dragon’s Prisoner</span> to celebrate Appreciate a Dragon Day, which is observed annually on January 16<span class="t6">th</span>. All you have to do to take part in the celebrations of this day is to appreciate stories and myths about dragons. Did you know that the first time the word dragon entered the English language was in the early 13<span class="t6">th</span> century, but descriptions of them have been found as far back as 4500 BC? They’re old beasts!</p>
<p class="p2"><span class="t1"> </span></p>
<p class="p2"><span class="t1"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?61356733